"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Look into why this exists.
 * @deprecated
 */
var CourseProductsModel = /** @class */ (function () {
    function CourseProductsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/courses",
            UPDATE: APPURL + "/api/v1/courses",
            CREATE: APPURL + "/api/v1/courses",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    CourseProductsModel.prototype.extract = function (result) {
        return result.data;
    };
    CourseProductsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    CourseProductsModel.prototype.create = function (product, courseId) {
        return this.$http
            .post(this.URLS.FETCH + "/" + courseId + "/products", product)
            .then(this.cacheResults);
    };
    return CourseProductsModel;
}());
CourseProductsModel.$inject = ["$http", "APPURL"];
exports.default = CourseProductsModel;
